/* import __COLOCATED_TEMPLATE__ from './see-what-data-attributes-can-do.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();